(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('login', {
                    parent: 'app.public',
                    url: '/login',
                    data: {
                        pageTitle: 'login.title'
                    },
                    views: {
                        'main@': {
                            templateUrl: 'app/components/login/login.html',
                            controller: 'LoginController',
                            controllerAs: 'vmLogin'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('login');
                                return $translate.refresh();
                            }]
                    }
                });
    }

})();